import React from 'react';
import { Image } from 'react-bootstrap';
import LoaderGif from './dualRing.gif';
const LoaderSvg = () => {
  return (
    <div className=" d-flex justify-content-center align-items-center">
      <Image
        src={LoaderGif}
        style={{ height: '20px', width: '20px' }}
        alt="Loader"
        roundedCircle
      />
    </div>
  );
};

export default LoaderSvg;
